export default {
	PERSON_ATTRIBUTES_TABLE: 'Person attribute types'
};
